import { useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook personalizado para reemplazar react-router-last-location
 * Almacena la última ubicación visitada
 */
const useLastLocation = () => {
  const location = useLocation();
  const lastLocationRef = useRef(null);

  useEffect(() => {
    // Solo actualizar si la ubicación actual es diferente a la última
    if (lastLocationRef.current?.pathname !== location.pathname) {
      lastLocationRef.current = location;
    }
  }, [location]);

  return lastLocationRef.current;
};

/**
 * Hook para guardar y obtener la última ubicación
 */
export const useLocationHistory = () => {
  const lastLocation = useLastLocation();

  const saveLastLocation = (location) => {
    if (location) {
      sessionStorage.setItem('lastLocation', JSON.stringify(location));
    }
  };

  const getLastLocation = () => {
    const saved = sessionStorage.getItem('lastLocation');
    return saved ? JSON.parse(saved) : lastLocation || { pathname: '/home' };
  };

  return {
    saveLastLocation,
    getLastLocation,
    lastLocation
  };
};
